import { render, staticRenderFns } from "./DashboardLiveStatisticsOneMatch.vue?vue&type=template&id=65650d37&scoped=true"
import script from "./DashboardLiveStatisticsOneMatch.vue?vue&type=script&lang=js"
export * from "./DashboardLiveStatisticsOneMatch.vue?vue&type=script&lang=js"
import style0 from "./DashboardLiveStatisticsOneMatch.vue?vue&type=style&index=0&id=65650d37&prod&lang=scss"
import style1 from "./DashboardLiveStatisticsOneMatch.vue?vue&type=style&index=1&id=65650d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65650d37",
  null
  
)

export default component.exports